// extracted by mini-css-extract-plugin
export default {"containerNews":"oneNews_containerNews__FAb1J","containerNewsBtn":"oneNews_containerNewsBtn__k5YjN"};